import AppConstants from 'constants/AppConstants';

interface State {
  query: {
    [key: string]: string;
  };
}

const initialState: State = {
  query: {},
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.SET_QUERIES: {
      return {
        ...state,
        query: payload,
      };
    }
    default:
      return state;
  }
}
